import { useParams } from 'react-router-dom';

import AuditHistoryAccordion from './AuditHistoryAccordion';
import Layout from './Layout';
import { useGetAssetAuditHistory } from './hooks';

export default function AssetAuditHistory() {
  const { assetId, assetTypeId } = useParams();

  const {
    data: auditHistory,
    isLoading,
    isError,
  } = useGetAssetAuditHistory(assetId, assetTypeId);

  return (
    <Layout
      pageEnum="ASSETS"
      isLoading={isLoading}
      isError={isError}
      isDataEmpty={!auditHistory?.length}
    >
      <AuditHistoryAccordion data={auditHistory} />
    </Layout>
  );
}
